var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "format" },
    [
      _c(
        "el-row",
        { staticClass: "padding-bottom", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [_c("app-divider", { attrs: { label: "Área de interesse" } })],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 12 } },
            [
              _c("app-label", { attrs: { label: "Número do recibo do CAR:" } }),
              _c("validation-provider", {
                attrs: { rules: "required|car", name: "Imóvel/N° do CAR" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: _vm.customMask,
                              expression: "customMask"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Número do recibo do CAR" },
                          model: {
                            value: _vm.imovel.numeroReciboCar,
                            callback: function($$v) {
                              _vm.$set(_vm.imovel, "numeroReciboCar", $$v)
                            },
                            expression: "imovel.numeroReciboCar"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("app-label", {
                attrs: { label: "Tempo de ocupação (em anos):" }
              }),
              _c("validation-provider", {
                attrs: { rules: "required", name: "Imóvel/Tempo ocupação" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("div", { staticClass: "tempo-ocupacao input" }, [
                          _c(
                            "div",
                            { staticClass: "select-size" },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: _vm.numberMask,
                                    expression: "numberMask"
                                  }
                                ],
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  size: "mini",
                                  name: "Tempo ocupação",
                                  min: "0"
                                },
                                model: {
                                  value: _vm.imovel.tempoOcupacao,
                                  callback: function($$v) {
                                    _vm.$set(_vm.imovel, "tempoOcupacao", $$v)
                                  },
                                  expression: "imovel.tempoOcupacao"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ],
                            1
                          ),
                          _c("span", [_vm._v("ano(s)")])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Imóvel/Ocupações Anteriores"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Há ocupantes anteriores?" }
                        }),
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "radio-group",
                            class: { erro: errors.length },
                            attrs: { name: "Ocupações Anteriores" },
                            model: {
                              value: _vm.imovel.ocupantesAnteriores,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "ocupantesAnteriores", $$v)
                              },
                              expression: "imovel.ocupantesAnteriores"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { staticClass: "radio", attrs: { label: true } },
                              [_vm._v("Sim")]
                            ),
                            _c(
                              "el-radio",
                              { staticClass: "radio", attrs: { label: false } },
                              [_vm._v("Não")]
                            )
                          ],
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Imóvel/Imóveis rurais no Pará"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label:
                              "Possui outros imóveis rurais no " +
                              _vm.ESTADO +
                              "?"
                          }
                        }),
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "radio-group",
                            class: { erro: errors.length },
                            attrs: { name: "Imóveis rurais no Pará" },
                            model: {
                              value: _vm.imovel.possuiImovel,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "possuiImovel", $$v)
                              },
                              expression: "imovel.possuiImovel"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { staticClass: "radio", attrs: { label: true } },
                              [_vm._v("Sim")]
                            ),
                            _c(
                              "el-radio",
                              { staticClass: "radio", attrs: { label: false } },
                              [_vm._v("Não")]
                            )
                          ],
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 6 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Imóvel/Conflitos no imóvel"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Há conflitos no imóvel?" }
                        }),
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "radio-group",
                            class: { erro: errors.length },
                            attrs: { name: "Conflitos no imóvel" },
                            model: {
                              value: _vm.imovel.conflitos,
                              callback: function($$v) {
                                _vm.$set(_vm.imovel, "conflitos", $$v)
                              },
                              expression: "imovel.conflitos"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { staticClass: "radio", attrs: { label: true } },
                              [_vm._v("Sim")]
                            ),
                            _c(
                              "el-radio",
                              { staticClass: "radio", attrs: { label: false } },
                              [_vm._v("Não")]
                            )
                          ],
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.imovel.conflitos
        ? _c(
            "el-row",
            { attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-label", {
                    attrs: {
                      label: "Nº do processo judicial:",
                      required: false
                    }
                  }),
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0" }, attrs: { span: 24 } },
                    [
                      _c("validation-provider", {
                        attrs: { name: "Imóvel/Conflitos no imóvel" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: {
                                      name: "Nº do processo judicial",
                                      maxlength: "100"
                                    },
                                    model: {
                                      value: _vm.imovel.numeroProcessoJudicial,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.imovel,
                                          "numeroProcessoJudicial",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "imovel.numeroProcessoJudicial"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          279656948
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-238218d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238218d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppImovelAreaInteresse.vue
// module id = null
// module chunks = 